import { useRouter } from 'expo-router';
import Button from '@/components/UI/Button';
import Icon from '@/components/Unistyles/Icon';

type OrganizationTeamActionsProps = {
  teamId: string;
  title: string;
  disabled: boolean;
};

export default function OrganizationTeamActions({
  teamId,
  title,
  disabled,
}: OrganizationTeamActionsProps) {
  const { push } = useRouter();

  return (
    <Button
      appearance="ghost"
      iconOnly
      size="lg"
      disabled={disabled}
      accessibilityLabel={`Manage team ${title}`}
      onPress={(event) => {
        event.stopPropagation();
        push({
          pathname: '/team/[teamId]/edit',
          params: { teamId },
        });
      }}
    >
      <Icon name="ellipsis-horizontal" variant="typographySecondary" />
    </Button>
  );
}
